import { useProfile } from '@core/hooks/useAccount';

// Fetches the customer profile once per session for every theme. useProfile
// copies the server name/email/mobile into the auth store, which is what every
// Header variant reads, so a name changed since login shows up everywhere.
// The query is disabled while logged out and shared (cached) with the account
// page, so this adds no extra request there.
export default function ProfileBootstrap() {
  useProfile();
  return null;
}
